import React from "react";

interface ConfirmDialogProps {
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmDialog({
  message,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-80 animate-fade-in">
        <p className="text-gray-800 text-center mb-6 text-base">{message}</p>

        <div className="flex justify-between gap-4">
          <button
            className="flex-1 bg-brand-primary text-white py-2 rounded-md"
            onClick={onCancel}
          >
            Cancel
          </button>

          <button
            className="flex-1 bg-green-500 text-white py-2 rounded-md"
            onClick={onConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
}
